import { ArticleFaq } from "@/components/site/ArticleFaq";
import { ArticleDisclaimer } from "@/components/site/ArticleDisclaimer";
import { AuthorBio } from "@/components/site/AuthorBio";
import { endMatterOrder } from "@/lib/article-variation";

type Props = {
  slug: string;
  faq: { q: string; a: string }[];
};

/**
 * Closing blocks of an article (FAQ, disclaimer, author box) rendered in a
 * slug-stable order so the library does not read as one repeated template.
 * The blocks themselves — and their content — are unchanged.
 */
export function ArticleEndMatter({ slug, faq }: Props) {
  const order = endMatterOrder(slug);
  const Faq = <ArticleFaq key="faq" items={faq} slug={slug} />;
  const Disclaimer = <ArticleDisclaimer key="disclaimer" />;
  const Bio = <AuthorBio key="bio" slug={slug} />;

  if (order === "bio-faq-disclaimer") return <>{[Bio, Faq, Disclaimer]}</>;
  if (order === "faq-bio-disclaimer") return <>{[Faq, Bio, Disclaimer]}</>;
  return <>{[Faq, Disclaimer, Bio]}</>;
}

export default ArticleEndMatter;
